import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { CrawlFbResponse } from '@/api/crawlFb';
import CrawlStatusDisplay from '../../CrawlFb/components/CrawlStatusDisplay';

interface CrawlDetailModalProps {
  isOpen: boolean;
  onClose: () => void;
  crawlData: CrawlFbResponse | null;
  onImageSelect?: (imageData: { imageUrl: string; title: string }) => void;
}

const CrawlDetailModal: React.FC<CrawlDetailModalProps> = ({
  isOpen,
  onClose,
  crawlData,
  onImageSelect,
}) => {
  if (!crawlData) return null;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent
        className="max-h-[95vh] overflow-y-auto p-0 border-0"
        style={{ maxWidth: '1400px', width: '90vw' }}
      >
        <DialogHeader className="px-6 pt-6 pb-0">
          <DialogTitle className="text-xl font-bold flex items-center gap-2">
            <span className="text-blue-600">📋</span>
            Chi tiết Crawl Facebook
          </DialogTitle>
        </DialogHeader>

        <div className="px-6 pb-6">
          <CrawlStatusDisplay
            crawlStatus={crawlData}
            isPolling={false}
            onNewCrawl={() => {}}
            isShowNewCrawl={false}
            onImageSelect={onImageSelect}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CrawlDetailModal;
